import { simplApi } from '../../api/simplApi';
import handleApiError from '../../helpers/handleApiError';
import { addFeedback } from './feedback';

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_PROFILESETTINGS = 'REQUEST_PROFILESETTINGS';
export const RECEIVE_PROFILESETTINGS = 'RECEIVE_PROFILESETTINGS';

// ------------------------------------
// Actions
// ------------------------------------
export function requestProfileSettings() {
  return {
    type: REQUEST_PROFILESETTINGS,
  };
}

export function receiveProfileSettings(settings) {
  return {
    type: RECEIVE_PROFILESETTINGS,
    payload: {
      settings,
    },
  };
}

export const fetchProfileSettings = () => dispatch => {
  dispatch(requestProfileSettings());

  const url = 'profilesettings';

  simplApi(url)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        dispatch(receiveProfileSettings(json));
      }
    });
};

export const saveProfileSettings = settings => dispatch => {
  dispatch(requestProfileSettings());

  const url = 'profilesettings/';
  const options = { method: 'post', body: { settings } };

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        dispatch(addFeedback('success', 'Einstellungen gespeichert'));
      }
    });
};

export const actions = {
  requestProfileSettings,
  receiveProfileSettings,
  fetchProfileSettings,
  saveProfileSettings,
};

const PROFILESETTINGS_ACTION_HANDLERS = {
  [REQUEST_PROFILESETTINGS]: state => ({
    ...state,
    fetching: true,
  }),
  [RECEIVE_PROFILESETTINGS]: (state, action) => ({
    ...state,
    settings: action.payload.settings,
    fetching: false,
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = { fetching: false, settings: {} };
export default function profileSettingsReducer(state = initialState, action) {
  const handler = PROFILESETTINGS_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/profilesettings.js